import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Avatar,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import { PhotoCamera } from "@mui/icons-material";
import PasswordInput from "../CommonComponents/PasswordInput";
import { toastAlert } from "../../helpers/toastAlert";
import { getProfile, changePassword } from "../../services/Profileservice";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { mustChangePassword } from "../../utils/commonutils";

/* ================= REGEX ================= */
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const mobileRegex = /^[6-9]\d{9}$/;
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

const Profile = (props) => {
  const [data, setData] = useState({});
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    currentPassword: "",
    newPassword: "",
  });

  /* ================= FETCH PROFILE ================= */
  const fetchProfile = async () => {
    const res = await getProfile(props);
    if (res?.data) {
      setData(res.data);
      setForm((prev) => ({
        ...prev,
        name: res.data.name || "",
        email: res.data.email || "",
        phone: res.data.mobile || "",
      }));
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= UPDATE PASSWORD ================= */
  const handleUpdatePassword = async () => {
    if (!form.currentPassword || !form.newPassword) {
      toastAlert("All password fields are required", "error");
      return;
    }

    if (!passwordRegex.test(form.newPassword)) {
      toastAlert(
        "Password must be 8+ chars with uppercase, lowercase, number & special character",
        "error",
      );
      return;
    }

    const payload = {
      oldPassword: form.currentPassword,
      newPassword: form.newPassword,
    };
    const res = await changePassword(props, payload);
    if (res?.code === 201) {
      // Changing the password signs out every older session, including this
      // one, so switch to the fresh token the API returns.
      if (res?.data?.token) {
        Cookies.set("ClaccessToken", res.data.token);
      }
      const wasForced = mustChangePassword();
      Cookies.remove("ClmustChangePassword");
      toastAlert("Password updated successfully", "success");
      if (wasForced) {
        props.history.push("/dashboard");
      }
      setForm({
        ...form,
        currentPassword: "",
        newPassword: "",
      });
    } else {
      toastAlert(
        res?.response?.data?.message || "Failed to Change-Password",
        "error",
      );
    }
  };

  return (
    <Box sx={{display:'flex', alignItems:"center" , width:"100%", justifyContent:'center', padding:"30px 0px "}}>
      <Box sx={{width:"960px"}}>
      {/* ===== HEADER ===== */}
      <Box mb={1} className="Profileheader">
        <Typography fontSize={22} fontWeight={600} sx={{ color: "white" }}>
          My Profile
        </Typography>
        <Typography fontSize={13} sx={{ color: "white", opacity: 0.8 }}>
          Manage your personal information and security
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {/* ===== RIGHT SECTION ===== */}
        <Grid item lg={6} md={7} xs={12}>
          {/* ===== CHANGE PASSWORD ===== */}
          <div className="card-main">
            <Typography fontWeight={600} mb={2}>
              Change Password
            </Typography>
            {mustChangePassword() && (
              <Box
                mb={2}
                p={1.5}
                sx={{ bgcolor: "#fff4e5", border: "1px solid #ffcc80", borderRadius: 2 }}
              >
                <Typography fontSize={14}>
                  Your password was reset by an admin. Enter the temporary
                  password as your current password and choose a new one to
                  continue.
                </Typography>
              </Box>
            )}
            <Divider sx={{ mb: 2 }} />
            <Grid container spacing={3}>
              {/* ===== CURRENT PASSWORD ===== */}
              <Grid item xs={12}>
                <PasswordInput
                  placeholder="Current Password"
                  name="currentPassword"
                  value={form.currentPassword}
                  onChange={handleChange}
                  autoComplete="current-password"
                />
              </Grid>

              {/* ===== NEW PASSWORD ===== */}
              <Grid item xs={12}>
                <PasswordInput
                  placeholder="New Password"
                  name="newPassword"
                  value={form.newPassword}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </Grid>
            </Grid>

            <Box mt={4} textAlign="right">
              <Button
                className="btn btn-colored"
                onClick={handleUpdatePassword}
              >
                Update Password
              </Button>
            </Box>
          </div>
        </Grid>

        {/* ===== LEFT PROFILE CARD ===== */}
        <Grid item lg={6} md={5} xs={12}>
          <div
            className="card-main"
            style={{
              height: "34vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box textAlign="center">
              <Box position="relative" display="inline-block">
                <Avatar sx={{ width: 90, height: 90 }}>
                  {data?.name?.[0] || "U"}
                </Avatar>
                <IconButton
                  size="small"
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    bgcolor: "#fff",
                  }}
                >
                  <PhotoCamera fontSize="small" />
                </IconButton>
              </Box>

              <Typography mt={2} fontWeight={600}>
                {data?.name}
              </Typography>
              <Typography fontSize={13} color="text.secondary">
                {data?.role}
              </Typography>
              <Typography fontSize={13}>{data?.email}</Typography>
              <Typography fontSize={13}>{data?.mobile}</Typography>
            </Box>
          </div>
        </Grid>
      </Grid></Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(Profile));
